import { Stack } from '@mui/material';
import { EmployeeDisplayDataProvider } from 'domain/shared/employee';
import { Alert } from 'framework/ui/mui-builder';
import { SetStaffingProjectData, StaffingAssignmentSlot, StaffingProjectData } from 'domain/shared/staffing';
import { useListContext } from 'framework/list';
import AssignmentSlot from './AssignmentSlot';

const AssignmentsList = ({
  projectData,
  setProjectData,
}: {
  projectData: StaffingProjectData;
  setProjectData?: SetStaffingProjectData;
}) => {
  const { data: { items = [] } = {} } = useListContext();
  const employeeAliases = Array.from(
    new Set(items.flatMap((slot: StaffingAssignmentSlot) => (slot?.members || []).map(member => member.employeeAlias))),
  );

  if (!items || items.length === 0) {
    return <Alert severity="info">No assignments available</Alert>;
  }

  return (
    <EmployeeDisplayDataProvider aliases={employeeAliases}>
      <Stack>
        {items.map((slot, index) => {
          return (
            <AssignmentSlot
              key={slot.id || `${slot.positionId}-${slot.requiredRole}-${index}`}
              slot={slot}
              projectData={projectData}
              setProjectData={setProjectData}
            />
          );
        })}
      </Stack>
    </EmployeeDisplayDataProvider>
  );
};
export default AssignmentsList;
